import React from "react";
import PropTypes from "prop-types";
import { colors } from "Constants/colorConstants";
const AIOutlined = props => {
  return (
    <svg
      width={props.width && props.width}
      height={props.height && props.height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9736 63.4039H50.779L54.9853 73.9067C55.7001 75.6858 56.5249 76.8337 57.4597 77.3502C58.4494 77.8667 59.3842 78.125 60.2639 78.125C61.6936 78.125 62.9307 77.6372 63.9754 76.6615C65.0751 75.6858 65.625 74.3084 65.625 72.5293C65.625 72.1849 65.57 71.7545 65.46 71.238C65.4051 70.7214 65.2401 70.1188 64.9652 69.4301L44.0982 20.7903C43.6034 19.6424 43.081 18.7242 42.5312 18.0355C41.9813 17.3468 41.404 16.8302 40.7991 16.4859C40.2493 16.1415 39.6994 15.912 39.1496 15.7972C38.5997 15.6824 38.0773 15.625 37.5825 15.625C37.0876 15.625 36.5653 15.6824 36.0154 15.7972C35.4655 15.912 34.9157 16.1415 34.3658 16.4859C33.816 16.8302 33.2661 17.3468 32.7163 18.0355C32.1664 18.7242 31.6441 19.6424 31.1492 20.7903L10.1173 69.6023C9.84238 70.291 9.64993 70.8936 9.53996 71.4101C9.42999 71.8693 9.375 72.3284 9.375 72.7875C9.375 74.4519 9.86987 75.7719 10.8596 76.7476C11.9043 77.6659 13.1415 78.125 14.5711 78.125C15.4509 78.125 16.3581 77.8667 17.2929 77.3502C18.2826 76.8337 19.1074 75.7145 19.7672 73.9928L23.9736 63.4039ZM47.1499 54.1064H27.6851L37.5 29.6574L47.1499 54.1064Z"
        fill={props.fill && props.fill}
      />
      <path
        d="M86.9792 75.198C87.3264 74.3945 87.5 73.3328 87.5 72.0127V21.7373C87.5 20.4746 87.3264 19.4416 86.9792 18.6381C86.6319 17.8346 86.2103 17.2033 85.7143 16.7441C85.2679 16.285 84.7718 15.998 84.2262 15.8833C83.6805 15.7111 83.2093 15.625 82.8125 15.625C82.4157 15.625 81.9444 15.7111 81.3988 15.8833C80.8532 15.998 80.3323 16.285 79.8363 16.7441C79.3899 17.2033 78.9931 17.8346 78.6458 18.6381C78.2986 19.4416 78.125 20.4746 78.125 21.7373V72.0127C78.125 73.3328 78.2986 74.3945 78.6458 75.198C78.9931 75.9441 79.3899 76.5467 79.8363 77.0059C80.3323 77.465 80.8532 77.752 81.3988 77.8667C81.9444 78.0389 82.4157 78.125 82.8125 78.125C83.2093 78.125 83.6805 78.0389 84.2262 77.8667C84.7718 77.752 85.2679 77.465 85.7143 77.0059C86.2103 76.5467 86.6319 75.9441 86.9792 75.198Z"
        fill={props.fill && props.fill}
      />
    </svg>
  );
};

AIOutlined.defaultProps = {
  height: 32,
  width: 32,
  fill: colors.neutral400,
};

AIOutlined.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

export default AIOutlined;
